// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.5981 5.20031C14.6997 2.26982 9.29751 2.26982 5.39914 5.20031L7.49862 5.20031L7.49862 7.20031L2.51334 7.20031L2.5127 1.50059L4.5127 1.50027L4.513 3.37132C8.98782 0.212551 15.0108 0.212814 19.4854 3.37211L19.4866 1.49996L21.4866 1.50132L21.4839 7.20031H16.4986V5.20031H18.5981Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.0008 4.81006C10.7527 4.81006 9.74083 5.8219 9.74083 7.07006V15.1337L7.0643 14.6049C6.31896 14.4577 5.5583 14.7739 5.13705 15.4062L4.1875 16.8314L8.48582 22.4227C9.00764 23.1014 9.81522 23.4993 10.6714 23.4993H17.7569C18.9437 23.4993 19.9973 22.7397 20.3723 21.6138L22.1548 16.2632C22.567 15.0257 22.0555 13.6687 20.929 13.0111L17.3043 10.8954C16.8826 10.6492 16.403 10.5195 15.9146 10.5195H14.2608V7.07006C14.2608 5.8219 13.249 4.81006 12.0008 4.81006Z"}}]};

const GestureSlideLeftAndRightFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'gesture-slide-left-and-right-filled',
    ref,
    icon: element,
  },
));

GestureSlideLeftAndRightFilledIcon.displayName = 'GestureSlideLeftAndRightFilledIcon';

export default GestureSlideLeftAndRightFilledIcon;
